export default __webpack_public_path__ + "static/media/bg.2e8c0851.webp";